import { useCagingCalendarStore } from '@p/a/r/calendar/context/hooks/store.hook';

import { CagingCalendarContext } from './calendar.context';

const CagingCalendarProvider = ({ children }: { children: React.ReactNode }) => {
  return <CagingCalendarContext.Provider value={useCagingCalendarStore()}>{children}</CagingCalendarContext.Provider>;
};

export default CagingCalendarProvider;
